<div class="hrn-alert text-center">
  <div *ngFor="let alert of alerts" class="alert-dismissible {{cssClass(alert)}}">
    {{alert.message}}
    <button type="button" class="btn-close" (click)="removeAlert(alert)"></button>
  </div>
</div>
